import React, { useEffect, useState } from "react";
import { Col, Container, Form, Row } from "react-bootstrap";

// css
import styles from "./addForm.module.scss";
import { Formik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import { NOTIFICATION_TEMPLATES } from "config/paths";
import AppInputField from "components/shared/FormComponents/AppInputField";
import { Breadcrumbs, CommonSelect, ReportsNoRecordMessage, RequiredFieldAstrick } from "components/Common/Common";
import LoadingIndicator from "components/shared/LoadingIndicator";
import LoadingOverlay from "components/shared/LoadingOverlay";
import LoadingButton from "components/shared/LoadingButton";
import AppDatePicker from "components/shared/FormComponents/AppDatePicker";
import { useEditNotificationTemplateMutation, useGetNotificationTemplatesQuery, useGetNotificationTemplateViewQuery } from "store/services/notifications";
import { AppRadioField } from "components/shared/FormComponents/AppRadioField";
import { NOTIFICATION_PRIORITY_OPTIONS } from "config/constants";
import { successMessageToast } from "helpers/common";



const EditNotifications = () => {

    const navigate = useNavigate();
    const { id: notificationId } = useParams();
    const [isOwner, setIsOwner] = useState(true)


    const breadcrumbItems = [
        { label: "Notification Templates", path: NOTIFICATION_TEMPLATES },
        { label: notificationId && "Edit" },
    ];

    const [initialValues, setInitialValues] = useState({ message_template: "", type_label: "", priority: "" });

    const { data, isFetching, isLoading, refetch } = useGetNotificationTemplateViewQuery({ id: notificationId }, { skip: !notificationId });
    const [editNotification, {isLoading: isEditLoading}] = useEditNotificationTemplateMutation();

    console.log('data', data)

    const handleSubmit = async (values, { resetForm }) => {
        console.log('values', values)
        try {
            const result = await editNotification({ id: notificationId, data: values }).unwrap();
            successMessageToast(result?.message);
            navigate(NOTIFICATION_TEMPLATES);
        } catch (error) {
            console.error("Error editing notification template:", error);     
        }
    };

    useEffect(() => {
        if (data) {
            setInitialValues({
                message_template: data?.message_template || "",
                type_label: data?.type_label || "",
                priority: data?.priority || ""
            });
        }
    }, [data]);

    return (
        <>
            <section className={`${styles.addForm} position-relative py-4 addForm h-100`}>
                <Container className="h-100">

                    <Row className="">
                        <Col lg="6">
                            <Breadcrumbs items={breadcrumbItems} />
                        </Col>
                    </Row>
                    {(isLoading) ? <LoadingIndicator /> : <Row className="h-100">
                        <Col lg="12" className="my-2">
                            {(false) && <LoadingOverlay blockClicks />}
                            <Formik
                                initialValues={initialValues}
                                // validationSchema={notesValidation}
                                onSubmit={handleSubmit}
                                enableReinitialize
                            >
                                {({
                                    handleSubmit,
                                    setFieldValue,
                                    isSubmitting,
                                    errors,
                                    values,
                                    touched,
                                    setFieldTouched
                                }) => (
                                    <>
                                        <Form onSubmit={handleSubmit}>
                                            <div className="reports-v2">
                                                <div className=" d-flex align-items-center justify-content-between" style={{ borderColor: "#315D99" }}>
                                                    {/* <h6 className="mb-0 section-title border-bottom-0" style={{ color: "#315D99" }}>{editMode ? "Edit TEMPLATES" : "SAVE A TEMPLATES"}</h6> */}
                                                </div>
                                                <Row >
                                                    <Col md="8" className="my-2 name-input-v2">
                                                        <label
                                                            htmlFor=""
                                                            className="discharge-screen-label mt-0"
                                                        >
                                                            Notification Message
                                                            <RequiredFieldAstrick />
                                                        </label>
                                                        <AppInputField
                                                            name="message_template"
                                                            className={`${styles.formControl} readonly-box h-auto`}
                                                            styles={{ border: "1px solid rgba(0,0,0,0.5)" }}
                                                        />
                                                    </Col>
                                                    <Col md="3" className="my-2 name-input-v2">
                                                        <label
                                                            htmlFor=""
                                                            className="discharge-screen-label mt-0"
                                                        >
                                                            Type Label
                                                            <RequiredFieldAstrick />
                                                        </label>
                                                        <AppInputField
                                                            name="type_label"
                                                            className={`${styles.formControl} readonly-box h-auto`}
                                                            styles={{ border: "1px solid rgba(0,0,0,0.5)" }}
                                                            placeholder="Enter type label"
                                                        />
                                                    </Col>

                                                    <Col md="3" className="my-2 name-input-v2">
                                                        <label
                                                            htmlFor=""
                                                            className="discharge-screen-label mt-0"
                                                        >
                                                            Priority
                                                            <RequiredFieldAstrick />
                                                        </label>
                                                        <AppRadioField
                                                            name="priority"
                                                            options={NOTIFICATION_PRIORITY_OPTIONS}
                                                        />
                                                    </Col>


                                                    <Col lg="12">
                                                        <div className="btnWrpper mt-2 d-flex justify-content-end my-2">
                                                            <LoadingButton
                                                                type="submit"
                                                                className="blue-discharge-screen-btn"
                                                                isLoading={isSubmitting || isEditLoading}
                                                            >
                                                                Save
                                                            </LoadingButton>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Form>
                                    </>
                                )}
                            </Formik>
                        </Col>
                    </Row>}
                </Container>
            </section >
        </>
    );
};

export default EditNotifications;
